module.exports = __webpack_public_path__ + "static/img/map.50824aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/map.png
// module id = AVj6
// module chunks = 0